import { isNative } from "@/lib/native";

export function WebOnlyPurchase({ children, compact = false }) {
  if (!isNative) return children;
  return (
    <p className={`text-muted-foreground ${compact ? "text-xs" : "text-sm"} text-center`} data-testid="native-purchase-notice">
      Purchases are managed through your Futuregen account on the web.
    </p>
  );
}
